import React, {Component} from "react";
import {Link} from "react-router-dom";
import flow1 from "../../../../../assets/img/flow1.png";
import './Guide.css';
import MetaTags from "react-meta-tags";


class Guide extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (


            <div className="static-pages">
                <MetaTags>
                    <title>ご利用規定｜プリント基板のネット通販｜KITCUT PCB </title>
                    <meta property="title" content="ご利用規定｜プリント基板のネット通販｜KITCUT PCB "/>
                    <meta name="title" content="ご利用規定｜プリント基板のネット通販｜KITCUT PCB "/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div">
                    <div className="row">

                        <p className="guide-title">ご利用規定</p>
                        <div className="spacer"></div>
                        {/*<a href="https://raksul.com/rules/">ご利用規約 参考</a>*/}
                        <p className="font-size-14 all-content-font-size"> 当社、RIZEN HK
                            LIMITED（以下「RIZEN」と表記する）が、お客様からお受けしたすべての注文については、以下に定める取引条件が<br className="br-mobile-resp"/>適用されます。<br/>
                            ※2019年3月1日制定
                        </p>
                    </div>
                    <div className="row">

                        <div className="static-pages-headings"> 目的及び適用
                        </div>
                        <ol className="margin-top-ol  all-content-font-size">
                            <li className='all-content-font-size-padding-bottom'> 本規約は、本サービスの利用条件及び本サービスの利用に関する当社と「ユーザー」（次条で定義する）との間の権利義務関係を定めることを目的とし、当社とユーザーとの間の本サービスの利用にかかる一切の関係に適用されます。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 当社が「当社ウェブサイト」（上に掲載する本サービス利用に関するルール及びガイドラインを含みます。※次条で定義する）は、本規約の一部を構成するものとします。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 本規約の内容と、前項のルールその他の本規約外における本サービスの説明等とが異なる場合は、本規約の規定が優先して適用されるものとします。
                            </li>
                        </ol>
                    </div>

                    <div className="row">

                        <p className="static-pages-headings"> 定義
                        </p>

                        <p className='all-content-font-size'> 本規約において使用する以下の用語は、それぞれ以下に定める意味を有するものとします。
                        </p>
                        <ol className='all-content-font-size'>


                            <li className='all-content-font-size-padding-bottom'> 「アカウント情報」とは、本サービスにおいてユーザーが使用するメールアドレス、ユーザーID及びパスワードを意味します。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「ガーバーファイル」とは、製造サービスの基となるデータのことを意味します。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「基板・メタルマスク製造サービス」とは、本サービスのうち、ユーザーが入稿したガーバーファイルを当社が用意する製造仕様の中からユーザーが選択した内容で製造・加工し、ユーザーが指定する場所に配送するサービスを意味します。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「個人情報」とは、個人情報の保護に関する法律（平成15年法律第57号、改正後の規定を含み、以下「個人情報保護法」といいます。）において定義される個人情報を意味します。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含み、著作権については著作権法『昭和45年法律第48号、その後の改正を含む』第27条及び第28条に定める権利を含む）を意味します。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「当社ウェブサイト」とは、そのドメインが「kitcutlabo.com」である、当社が運営するウェブサイト（当社のウェブサイトのドメイン又はその内容が変更された場合は、当該変更後のウェブサイトを含む）を意味します。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「パートナー企業」とは、当社がユーザーに対して本サービスの提供を行うための補助者として、当社との間で本サービスに関する契約を締結した個人又は法人を意味します。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「本商品」とは、製造サービスにおいて製造・加工した商品をいいます。
                            </li>
                            <li className='all-content-font-size-padding-bottom'>
                                「本契約条件」とは、ユーザーが当社ウェブサイトにおいて入力し、当社ウェブサイト及び当社からユーザーに対して送信されるメールその他の方法を通じてユーザーに通知される、当該個別契約に適用される一切の契約条件をいいます。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「本サービス利用契約」とは、本規約に基づいて当社とユーザーの間で締結される、本サービスの利用に関する契約を意味します。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「製造費用」とは、個別契約に基づく本サービス提供の対価として、ユーザーが当社に対して支払う金銭（本商品の配送費用その他本サービス提供に関してユーザーが負担する費用を含む）をいいます。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 「ユーザー」とは、本サービスの利用者としての登録がなされた個人又は法人を意味します。
                            </li>
                        </ol>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 一般条件
                        </p>
                        <ul className='all-content-font-size'>RIZENは、すべての販売を本規約に従って取り扱うものとします。なお、本規約は、本サイト又はその他のいかなる条件にも優先します。また、RIZENの書面による同意がない限り、本規約は、商品の取引にかかるRIZENとお客様との間の完全なる合意とし、お客様が注文書又はRIZENとお客様との間の交渉もしくは取引過程において提言、記載し又は言及されたいかなる条件も無効とします。
                            本ウェブサイト又はお客様に提示された価格表等に含まれるすべての記載内容は、商品の概要を示すためのものであり、いずれもRIZENとお客様との間の契約の一部をなすものではありません。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 価格と書類
                        </p>
                        <ul className='all-content-font-size'> 商品の提示価格には、内国法律に従って輸入諸費用、内国消費税、送料全てを含みます。
                        </ul>
                        <ul className='all-content-font-size'> RIZENは、本ウェブサイトにおける提示価格を維持するよう努力しますが、為替変動により注文受領前のいかなるときにおいても、お客様への事前の通知なく、当該価格を変更することがあります。
                        </ul>
                        <ul className='all-content-font-size'> 弊社が発行する注文明細書、請求書の金額は、システム内で単価1円以下を保持して計算していますので、表記の単価は1円以下を四捨五入しており「単価×数量＝金額」に差異が発生する場合あります。しかしながら、弊社発行の注文明細書、請求書に記載の金額は正であり、また印鑑の類は省いておりますが、正式な書類として受領願います。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 発注
                        </p>
                        <ul className='all-content-font-size'> RIZENは、お客様の依頼に従って注文を処理し、また、注文数が本ウェブサイト記載の最小販売単位未満の場合は、最小単位数の注文となりますので予めご了承ください。万が一注文された商品が製造上の仕様により良品が確保できないと判断した場合には、キャンセルとさせていただきます。
                        </ul>
                        <ul className='all-content-font-size'> RIZENは、いずれの取引もお断りする権利を有するものとします。さらに、本規約の他の条項や代金受領の如何に拘わらず、RIZENは<br className="br-mobile-resp"/>(週末及び祝日を除き）RIZENが注文を受けてから24時間以内に、お客様に対して、当該注文を受諾しない旨の通知をEmailですることに<br className="br-mobile-resp"/>より、これをお断りできるものとします。RIZENが、代金受領済みの注文をお断りした場合には、かかる代金の全額を返金致します。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 検査、輸送の遅滞及び引渡がなされない場合
                        </p>
                        <ul className='all-content-font-size'> お客様は、商品引渡後、合理的かつ可及的速やかに商品を検査し、引渡後30日以内に、商品の瑕疵又は商品に対する苦情につき、その詳細をRIZEN
                            に通知するものとします。お客様からの通知がない場合、商品は契約に準拠しており、かつ瑕疵がなかったものとして、お客様が、当該商品を受諾したとみなします。お客様が、商品が契約に従ったものでないか又は瑕疵があることを証明し、RIZENが合意した場合、かかる不履行又は瑕疵に関するお客様への救済方法は、RIZENが、商品の交換又は代金の払戻し、あるいはお客様がRIZEN
                            に対して代金の支払い義務を有している場合には、商品の返却と引き替えでのクレジットを受けることのいずれかを選択するものとします。
                        </ul>
                        <ul className='all-content-font-size'> お客様が受領した商品に数量不足がある場合には、商品引渡日から8日以内に、本サイトよりお問い合わせください。
                        </ul>
                        <ul className='all-content-font-size'> いかなる状況でも、RIZENは、理由の如何を問わず、商品の全部又は一部が引き渡されないか又は引渡しが遅滞した結果生じた損害等について、損害賠償等の補償責任を負わないものとします。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> リスク負担及び所有権
                        </p>
                        <ul className='all-content-font-size'> 商品の損失又は損害のリスク負担は、お客様がすべての代金の支払いが完了し、商品引渡時をもって、お客様に移転されるものとします。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 保証
                        </p>
                        <ul className='all-content-font-size'> RIZENに対して書面によるクレームがなされることを条件として、RIZENの判断に基づいて、RIZENによって提供され、適正な使用状態で隠れたる瑕疵が発見された商品につき、交換もしくは修理、又は代金の払戻しをなすことを保証します。但し、かかるクレームに関わる商品又は部品は、当該期間内に、適切に梱包され、又は、RIZENが商品引渡時にお客様に通知した特定の指示があればそれに従って、RIZENに返却されることを条件とします。返却する商品又は部品には、当該商品に関する請求書番号及びクレームの対象となる瑕疵の性質、並びにRIZENが引渡時に提示した追加情報について記載した通知書を添付してください。なお、RIZENが交換のために受領した商品又は部品は、RIZENの所有物となります。本保証は、商品の品質又は特定目的適合性に関する法律による保証又は条件（法律によって除外され得ない保証又は条件を除く）に優先するものとします。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 責任
                        </p>
                        <ul className='all-content-font-size'>
                            RIZENは、RIZENやその従業員、代理人又は下請業者等の契約違反や法令違反、その他の過失や法令上の責任に基づいて商品に起因してお客様に生じた損害について、相当な範囲で責任を負うものとしますが、その損害は注文いただいた商品の請求金額以内とします。
                            商品の隠れたる瑕疵によってお客様に損害が生じた場合、RIZENは本規約に定める保証に基づいて瑕疵のない商品との交換もしくは修理、又は代金の払い戻しに応ずることで対応するものとし、それ以上にはお客様の損害について責任を負わないものとします。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> お支払い
                        </p>
                        <ul className='all-content-font-size'> クレジット決済・ペイパル決済：本ウェブサイトからのご注文のみご利用いただけます。
                        </ul>
                        <ul className='all-content-font-size'> すべてのお支払いは、相殺、控除または反対請求なしに支払うものとします。
                        </ul>
                    </div>
                    <div className="row">


                        <p className="static-pages-headings"> 輸出規制
                        </p>
                        <ul className='all-content-font-size'> 国際的な平和及び安全維持の観点から外為法48条および25条に基づく武器及び大量破壊兵器関連貨物・技術におけるリスト規制、又は通常兵器及び大量破壊兵器等の不拡散の為の補完的輸出規制（キャッチオール規制）に該当する商品（技術を含む）を輸出される場合は、お客様の責任において必ず経済産業省の輸出許可を取得してください。同様に米国政府の定める米国輸出管理規則（EAR）及び米国再輸出規制の対象となる商品（技術を含む）を輸出する際は規則に則り適切な審査を行い、米国商務省の再輸出許可等を取得してください。また規制されるか否かに拘わらず、商品を輸出される場合は顧客審査・用途確認を行い、大量破壊兵器等の開発・製造・使用・貯蔵に流用されている場合、若しくはその恐れのある場合、又は軍事用途・軍事研究などに用いられることが判明している場合は、輸出は行わないでください。上記に反して不正に輸出された場合は刑事罰、行政罰、社会的制裁等が課されますので十分にご注意ください。RIZEN並びにRIZENが提供する商品の製造元は、日本国内における消費を前提として商品（技術を含む）の販売を行っているため、これらに起因する障害・損害に対して一切責任を負わないものとします。
                        </ul>
                    </div>
                    <div className="row">


                        <p className="static-pages-headings"> 返品
                        </p>
                        <ul className='all-content-font-size'> 保証に基づく返品については、お客様が事前に返品受付番号を取得され、かつ当該返品希望時にRIZENからお客様に通知される運送業者を利用することを条件として、かつお客様が返品のための送料を負担するものとします。
                        </ul>
                        <ul className='all-content-font-size'> すべての商品は、お客様のリスク負担で返品され、RIZENは、商品のいかなる損失又は損害についても、又はお客様が商品に加えたものでかつ商品と共にRIZENに送付された部品等のいかなる損失又は損害についても一切責任を負わないものとします。
                        </ul>
                        <ul className='all-content-font-size'> RIZENへ返品される商品は、適切に梱包されかつ返品受付番号を明記した送り状をしっかりと貼付して発送してください。返品お申し込み後に、メールにて返送先住所などの返品手順についてお知らせします。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 注文のキャンセル
                        </p>
                        <ul className='all-content-font-size'> 一旦、決済が完了されたご注文のキャンセルは、原則としてお受けしておりません。ご注文の際に十分内容をご確認ください。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 著作権及び特許
                        </p>
                        <ul className='all-content-font-size'> 本ウェブサイトにおいて販売されている商品は、特許、商標、登録意匠、著作権、フォトグラフィー権又はその他の権利を有する者の当該権利に従うものとします。RIZENは、本ウェブサイトに関する完全な著作権を所有しており、RIZENの書面による事前同意なしに、本ウェブサイトの全部又は一部を複製することは禁じられています。
                        </ul>
                    </div>
                    <div className="row">


                        <p className="static-pages-headings"> 不可抗力
                        </p>
                        <ul className='all-content-font-size'> RIZENの合理的支配を越えた原因により、又は増額価格で確保できる場合を除き契約履行のために必要な役務、素材又は物品をRIZENが確保できないため、RIZENが契約を履行できない場合には、RIZENは、自己の単独の選択で、かかる契約の全部又は一部の履行を遅滞させ又は取消すことができ、RIZENは、かかる遅滞もしくは取消又は引渡しができないことについて、何ら責任を負わないものとします。特に、RIZENは、RIZENが合意した日付までに受注した商品を引き渡せるよう、合理的に最善を尽くしますが、RIZENは、かかる受注商品の引渡の遅滞又はかかる受注商品を引渡せないことについて、何ら責任を負わないものとします。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 法律の選択
                        </p>
                        <ul className='all-content-font-size'> RIZENとお客様との間の契約は、すべて香港特別行政区基本法を準拠法とし、かつこれに従って解釈されるものとします。商品の売買に関して生じた紛争が、協議によって解決されない場合、当該紛争については、香港司法機構が専属的裁判管轄権を有するものとします。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> お客様へのお願い
                        </p>
                        <ul className='all-content-font-size'> RIZENではウェブサイト掲載価格での販売を行っており、仕様・数量に応じた金額を商品ページに表示しております。注文明細・請求書が必要な場合は、マイアカウントよりご利用頂けます。
                        </ul>
                        <ul className='all-content-font-size'> RIZEN は一定の数量を超える大量注文には対応できない場合があります。
                        </ul>
                        <ul className='all-content-font-size'> 本ウェブサイトの使用は記載された取引条件及びプライバシーポリシーに同意したものとみなします。本ウェブサイト記載内容のすべての著作権はRIZEN若しくはそのライセンシーに帰属します。ウェブサイトの記載内容はその製品の品質・仕様その他を保障するものではなく、またリンクするウェブサイトの内容につき保障するものではありません。
                        </ul>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 製品使用に関する注意事項
                        </p>
                        <ol className='all-content-font-size'>
                            <li className='all-content-font-size-padding-bottom'> 当ウェブサイトにて提供している製造サービスはプロトタイプ品に使用されることを意図しています。特別に高い品質・信頼性が要求され、その故障や誤作動が直接人命を脅かしたり、人体に危害を及ぼす恐れのある機器（原子力制御機器、航空宇宙機器、交通輸送機器※、交通信号機器、燃焼制御、医療機器、各種安全装置、軍事用機器、海底用機器など）にこれらの部品に使用すること（以下“特定用途”という）を意図して、製造されたものではありません。特定用途に使用されたことに起因して生じたいかなる損失、損害も、弊社および商品の製造元では一切責任を負いかねますので、ご了承ください。当ウェブサイトにて提供している製造サービスを特定用途に使用することは、お客様の責任でなされることになります。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 用途の如何にかかわらず、高い安全性が求められる機器にお使いになるときは、保護回路や冗長設計・回路を設けて機器の安全を図られると同時にお客様において安全性のテストおよび検証の実施などシステム・機器全体の安全に配慮していただいた上でご使用されることをお勧めします。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 電子部品全般で、以下に示すような特殊な環境でのご使用の際は、十分に性能、信頼性などをご確認ください。

                                <ul className='all-content-font-size-padding-bottom'> a. 液体（水、油、薬液、有機溶剤等）中でのご使用
                                </ul>
                                <ul className='all-content-font-size-padding-bottom'> b.
                                    直射日光、屋外暴露、塵埃、腐食性ガス（潮風、Cl2、H2S、NH3、SO2、NO2等）中でのご使用
                                </ul>
                                <ul className='all-content-font-size-padding-bottom'> c. 静電気、電磁波の強い環境下でのご使用
                                </ul>
                                <ul className='all-content-font-size-padding-bottom'> d. 製品が結露するような環境下でのご使用
                                </ul>
                                <ul className='all-content-font-size-padding-bottom'> e.
                                    無洗浄はんだ付けやはんだ付け後のフラックス洗浄で水及び水溶性洗浄をご使用の場合
                                </ul>

                            </li>
                            <li className='all-content-font-size-padding-bottom'> 保管条件については、腐食ガス（潮風、Cl2、H2S、NH3、SO2、NO2等）の多い場所、直射日光の当たる場所での保管は、性能劣化、製品自体の故障の原因となりますので避けてください。
                            </li>
                            <li className='all-content-font-size-padding-bottom'> 落下などによる衝撃を与えると破損する恐れがあり、故障の原因となりますので取り扱いには十分ご注意ください。
                            </li>

                        </ol>
                    </div>
                    <div className="row">

                        <p className="static-pages-headings"> 交通輸送機器に関する注意事項
                        </p>
                        <ul className='all-content-font-size'> 当社販売製品で、人命に影響し、あるいは社会的に甚大な損失を与える恐れのある機器に使用される際は、お客様において十分テストの上ご判断ください。
                        </ul>
                        <ul className='all-content-font-size'> 交通輸送機器でも自動車など重要保安部品（車の走る、曲がる、止まるを直接制御する部品、機器）でのご使用は避けてください。
                        </ul>
                        <ul className='all-content-font-size'> 性能に対して余裕を持った使い方やフェールセーフ等の安全対策へのご配慮をお願いします。
                        </ul>
                    </div>
                </div>
            </div>

        );
    }


}

export default Guide;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/Guide.js